import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { VscOutput } from "react-icons/vsc";
const Name = () => {
  const [onClick, setOnCLick] = useState(false);
  const [onSearching, setSearching] = useState(false);
  const onClickHandler = (e) => {
    setOnCLick(!onClick);
  };
  const selectHandler = () => {
    setSearching(!onSearching);
  };
  return (
    <div
      className={`${
        onClick ? "flex flex-col border-blue-700 border mr-1 h-auto" : ""
      }`}
    >
      <button
        onClick={onClickHandler}
        className="flex flex-row justify-between w-full hover:bg-gray-100"
      >
        <div className="flex items-center px-2 h-12 hover:text-blue-600 font-medium">
          <VscOutput />
          <div className="ml-2 text-sm">Name</div>
        </div>
        <div className="m-4">
          {!onClick ? (
            <FaCaretDown className="text-gray-500" />
          ) : (
            <FaCaretUp className="text-gray-500" />
          )}
        </div>
      </button>
      {onClick && (
        <div className="flex flex-col items-center justify-center py-3 w-full">
          <form action="">
            <input
              className="h-[1.7rem] focus:outline-none rounded-sm w-[18rem] border border-gray-300 hover:border-blue-600"
              type="text"
              placeholder="Enter name..."
            />
          </form>
        </div>
      )}
    </div>
  );
};

export default Name;
